/**
 *  Keycap "See Details" modal (homepage keycap tabs section).
 *
 *  Port of the approved M3c mockup. The dialog shell lives in
 *  snippets/keycap-modal.liquid, the product list in
 *  snippets/keycap-modal-data.liquid (#KeycapModalData); cards are built
 *  here on open. Exposes window.KeycapModal = { open, openList, close }.
 *  No dependencies, no other globals, no errors when the modal never opens.
 */
(function () {
  'use strict';

  var SWIPE_START = 8;
  var SWIPE_GO = 60;
  var CARD_DRAG_LIMIT = 10; /* homepage cards: pointer travel (px) that counts as a row drag */
  var LAND_TOP = 58;
  var LAND_BOTTOM = 14;

  function init() {
    // Note: the shell element (id="KeycapModal") shows up as a window property,
    // so check for our own API object instead of the global name itself.
    if (window.KeycapModal && typeof window.KeycapModal.open === 'function') {
      return;
    }
    var km = document.getElementById('KeycapModal');
    var dataEl = document.getElementById('KeycapModalData');
    if (!km || !dataEl) {
      return;
    }

    var items = [];
    var lists = null;
    try {
      var parsed = JSON.parse(dataEl.textContent || '{}');
      if (parsed && parsed.items && parsed.items.length) {
        items = parsed.items;
      }
      if (parsed && parsed.lists && typeof parsed.lists === 'object') {
        lists = parsed.lists;
      }
    } catch (e) {
      items = [];
      lists = null;
    }
    if (!items.length) {
      return;
    }
    var hasLists = false;
    if (lists) {
      for (var listName in lists) {
        if (Object.prototype.hasOwnProperty.call(lists, listName)
          && lists[listName] && lists[listName].handles && lists[listName].handles.length) {
          hasLists = true;
          break;
        }
      }
    }
    if (!hasLists) {
      lists = null;
    }

    function translated(name, fallback) {
      var value = km.getAttribute('data-t-' + name);
      return value === null ? fallback : value;
    }

    var t = {
      learnMore: translated('learn-more', 'Learn More'),
      addToCart: translated('add-to-cart', 'Add to cart'),
      previous: translated('previous', 'Previous'),
      next: translated('next', 'Next'),
      close: translated('close', 'Close'),
      added: translated('added', 'Added'),
      addError: translated('add-error', "Couldn't add to cart. Please try again."),
      rotate: translated('rotate', 'Rotate to landscape'),
      unrotate: translated('unrotate', 'Back to portrait'),
      chooseOption: translated('choose-option', 'Choose an option'),
      chooseOptions: translated('choose-options', 'Choose options'),
      change: translated('change', 'Change'),
      soldOut: translated('sold-out', 'Sold out'),
      wlAdd: translated('wl-add', 'Add to wishlist'),
      allKeycaps: translated('all-keycaps', 'All Keycaps')
    };
    /* wishlist heart icon (snippets/wishlist-icon.liquid); state is synced by assets/wishlist.js */
    var wlTpl = km.querySelector('template[data-km-wl-heart]');
    var wlIcon = wlTpl ? wlTpl.innerHTML : '';
    var sectionUrls = km.getAttribute('data-sections') || 'main-cart,cart-drawer,cart-bubble';
    var quickAtc = km.getAttribute('data-quick-atc') === 'true';

    var stage = km.querySelector('.km-stage');
    var counterEl = km.querySelector('.km-count');
    var statusEl = km.querySelector('.km-status');
    var listBar = null;
    var listBarTitle = null;
    var listBarProgress = null;
    var listBarView = null;
    var listBarViewLabel = null;
    var coarse = window.matchMedia ? window.matchMedia('(pointer:coarse)') : { matches: false };

    var cards = [];
    var builtListKey = null;
    var built = false;
    var currentItems = items;
    var currentListKey = null;
    var isOpen = false;
    var active = 0;
    var rotated = false;
    var opener = null;
    var scrollLock = null;
    var statusTimer = 0;

    var icons = {
      exp: '<svg class="i-exp" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M3 8V3h5M17 8V3h-5M3 12v5h5M17 12v5h-5"/></svg>',
      col: '<svg class="i-col" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M8 3v5H3M12 3v5h5M8 17v-5H3M12 17v-5h5"/></svg>',
      cart: '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M2.3 3.3L4.3 3.8Q5.1 4 5.3 4.8L5.9 7.2"/><path d="M5.7 7.4Q5.5 6.2 6.8 6.2H19.6Q21.2 6.2 20.9 7.8L20 13.3Q19.6 15.9 17 15.9H9.4Q7.3 15.9 6.9 13.8Z"/><path d="M7.3 15.4Q7.8 18 10 18H18.3"/><circle cx="9.9" cy="20.6" r="1.5"/><circle cx="17.3" cy="20.6" r="1.5"/><circle cx="11.1" cy="10.2" r="1.35" fill="currentColor" stroke="none"/><circle cx="16" cy="10.2" r="1.35" fill="currentColor" stroke="none"/><path d="M11.4 12.6q2.15 1.9 4.3 0"/></svg>',
      plus: '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round"><path d="M12 6.6v10.8M6.6 12h10.8"/></svg>',
      check: '<svg aria-hidden="true" focusable="false" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3.5 8.4l3 2.9 6-6.4"/></svg>'
    };

    function esc(value) {
      return String(value).replace(/[&<>"]/g, function (c) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c];
      });
    }
    function indexOfHandle(handle) {
      if (!handle) {
        return -1;
      }
      for (var i = 0; i < items.length; i++) {
        if (items[i].handle === handle) {
          return i;
        }
      }
      return -1;
    }
    function indexOfHandleIn(list, handle) {
      if (!handle || !list) {
        return -1;
      }
      for (var i = 0; i < list.length; i++) {
        if (list[i].handle === handle) {
          return i;
        }
      }
      return -1;
    }
    function itemsForList(listKey) {
      if (!lists) {
        return items;
      }
      var list = listKey ? lists[listKey] : null;
      var handles = list && list.handles ? list.handles : [];
      var result = [];
      for (var i = 0; i < handles.length; i++) {
        var itemIndex = indexOfHandle(handles[i]);
        if (itemIndex >= 0 && indexOfHandleIn(result, handles[i]) < 0) {
          result.push(items[itemIndex]);
        }
      }
      return result;
    }
    function itemsForListTrigger(listKey) {
      if (!listKey) {
        return [];
      }
      if (!lists) {
        return listKey === 'all' ? items : [];
      }
      return lists[listKey] ? itemsForList(listKey) : [];
    }
    function listHasHandle(listKey, handle) {
      if (!lists || !listKey || !lists[listKey]) {
        return false;
      }
      var listItems = itemsForList(listKey);
      for (var i = 0; i < listItems.length; i++) {
        if (listItems[i].handle === handle) {
          return true;
        }
      }
      return false;
    }
    function resolveListKey(requested) {
      if (!lists) {
        return null;
      }
      if (requested && lists[requested] && itemsForList(requested).length) {
        return requested;
      }
      return lists.all && itemsForList('all').length ? 'all' : null;
    }
    function resolveHandleTarget(handle, requestedListKey) {
      if (!handle) {
        return null;
      }
      if (!lists) {
        var itemIndex = indexOfHandle(handle);
        return itemIndex >= 0 ? { listKey: null, index: itemIndex } : null;
      }
      var listKey = resolveListKey(requestedListKey);
      if (listHasHandle(listKey, handle)) {
        return { listKey: listKey, index: indexOfHandleIn(itemsForList(listKey), handle) };
      }
      if (listKey !== 'all' && listHasHandle('all', handle)) {
        return { listKey: 'all', index: indexOfHandleIn(itemsForList('all'), handle) };
      }
      return null;
    }
    function makeListBar() {
      if (!hasLists || listBar) {
        return;
      }
      listBar = document.createElement('div');
      listBar.className = 'km-listbar';
      listBar.innerHTML = '<div class="km-listbar__meta" aria-live="polite">'
        + '<strong class="km-listbar__title"></strong>'
        + '<span class="km-listbar__sep" aria-hidden="true">·</span>'
        + '<span class="km-listbar__progress"></span>'
        + '</div>'
        + '<a class="km-view" href=""><span class="km-view__label">View</span> <span class="km-view__arrow" aria-hidden="true">→</span></a>';
      listBarTitle = listBar.querySelector('.km-listbar__title');
      listBarProgress = listBar.querySelector('.km-listbar__progress');
      listBarView = listBar.querySelector('.km-view');
      listBarViewLabel = listBar.querySelector('.km-view__label');
      km.classList.add('km--lists');
    }
    function mountListBar() {
      if (!listBar) {
        return;
      }
      var card = cards[active];
      if (card) {
        card.insertBefore(listBar, card.firstChild);
      } else if (listBar.parentNode) {
        listBar.parentNode.removeChild(listBar);
      }
    }
    function updateListBar() {
      if (!hasLists || !listBar) {
        return;
      }
      var list = lists[currentListKey] || lists.all;
      var count = currentItems.length;
      if (!list) {
        return;
      }
      listBarTitle.textContent = list.title || t.allKeycaps;
      listBarProgress.innerHTML = '<b>' + (active + 1) + '</b>/' + count;
      listBarView.href = list.url || '';
      listBarViewLabel.textContent = 'View';
      mountListBar();
      if (counterEl) {
        counterEl.innerHTML = '<b>' + (active + 1) + '</b> / ' + count;
      }
    }
    function centsPrice(value) {
      if (value === null || value === undefined || String(value).trim() === '') {
        return null;
      }
      var cents = Number(value);
      return isFinite(cents) && cents >= 0 ? (cents / 100).toFixed(2) : null;
    }
    function activeCurrency() {
      try {
        var cur = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
        return typeof cur === 'string' && /^[A-Z]{3}$/.test(cur) ? cur : null;
      } catch (e) {
        return null;
      }
    }
    function cleanVariantTitle(value) {
      if (typeof value !== 'string') {
        return null;
      }
      var title = value.trim();
      return !title || title.toLowerCase() === 'default title' ? null : title;
    }
    function wishlistMeta(item, selected) {
      var variants = item && item.variants ? item.variants : [];
      var variant = selected || variants[0] || null;
      var cents = variant && variant.price_cents !== null && variant.price_cents !== undefined ? variant.price_cents : (item ? item.price_cents : null);
      return {
        variantId: variant && variant.id ? variant.id : (item ? item.variant : null),
        productTitle: item ? (item.product_title || item.title || null) : null,
        variantTitle: item && item.has_variants && variant ? cleanVariantTitle(variant.title) : null,
        priceCents: cents,
        price: centsPrice(cents),
        currency: activeCurrency()
      };
    }
    function heartAttrs(item) {
      var meta = wishlistMeta(item, null);
      var attrs = ' data-product-title="' + esc(meta.productTitle || '') + '"';
      if (meta.priceCents !== null && meta.priceCents !== undefined) {
        attrs += ' data-price-cents="' + esc(meta.priceCents) + '"';
      }
      if (item.has_variants && meta.variantId) {
        attrs += ' data-variant-id="' + esc(meta.variantId) + '"';
        if (meta.variantTitle) {
          attrs += ' data-variant-title="' + esc(meta.variantTitle) + '"';
        }
      }
      return attrs;
    }
    function syncHeart(el, selected) {
      var heart = el ? el.querySelector('[data-wishlist-toggle]') : null;
      if (!heart) {
        return;
      }
      var meta = wishlistMeta(el._item, selected);
      heart.setAttribute('data-product-title', meta.productTitle || '');
      if (meta.priceCents !== null && meta.priceCents !== undefined) {
        heart.setAttribute('data-price-cents', String(meta.priceCents));
      } else {
        heart.removeAttribute('data-price-cents');
      }
      if (el._item && el._item.has_variants && meta.variantId) {
        heart.setAttribute('data-variant-id', String(meta.variantId));
        if (meta.variantTitle) {
          heart.setAttribute('data-variant-title', meta.variantTitle);
        } else {
          heart.removeAttribute('data-variant-title');
        }
      } else {
        heart.removeAttribute('data-variant-id');
        heart.removeAttribute('data-variant-title');
      }
    }

    /* ---- card DOM (built on open, rebuilt when the active list changes) ---- */
    function build(force) {
      if (built && !force && builtListKey === currentListKey) {
        return;
      }
      closePicker(false);
      if (listBar && listBar.parentNode && stage.contains(listBar)) {
        listBar.parentNode.removeChild(listBar);
      }
      while (stage.firstChild) {
        stage.removeChild(stage.firstChild);
      }
      cards = [];
      built = true;
      builtListKey = currentListKey;
      currentItems.forEach(function (item, i) {
        var el = document.createElement('article');
        el.className = 'km-card';
        el.setAttribute('aria-roledescription', 'slide');
        el.setAttribute('aria-label', (i + 1) + ' of ' + currentItems.length + ': ' + item.title);
        var html = '';
        if (item.img) {
          html += '<div class="km-img' + (item.fb ? ' is-fallback' : '') + '">'
            + '<img data-src="' + esc(item.img) + '" data-full="' + esc(item.full || item.img) + '" alt="' + esc(item.title) + '">'
            + '<button class="km-rot" type="button" aria-pressed="false" aria-label="' + esc(t.rotate) + '">' + icons.exp + icons.col + '</button>'
            + (wlIcon && item.handle ? '<button class="wl-heart" type="button" data-wishlist-toggle data-wishlist-source="modal" data-handle="' + esc(item.handle) + '" data-product-id="' + esc(item.id || '') + '"' + heartAttrs(item) + ' aria-pressed="false" aria-label="' + esc(t.wlAdd) + '">' + wlIcon + '</button>' : '')
            + '</div>';
        } else {
          html += '<div class="km-img is-empty" aria-hidden="true"></div>';
        }
        var tags = (item.tags || []).map(function (tag) {
          return '<span class="km-tag' + (/\bKeys$/i.test(tag) ? ' km-tag--keys' : '') + '">' + esc(tag) + '</span>';
        }).join('');
        var price = (item.price || '') + (item.compare ? '<del>' + item.compare + '</del>' : '');
        var atc = '';
        var multi = !!(item.multi && item.variants && item.variants.some(function (v) { return v.available; }));
        if (quickAtc && item.available && multi) {
          atc = '<button class="km-atc2 km-atc2--pick" type="button" aria-label="' + esc(t.chooseOptions) + '" aria-haspopup="listbox" aria-expanded="false">'
            + icons.plus + '</button>';
        } else if (quickAtc && item.variant && item.available) {
          atc = '<button class="km-atc2" type="button" aria-label="' + esc(t.addToCart) + '">'
            + icons.cart + '</button>';
        }
        html += '<div class="km-bar"><div class="km-id"><h2 class="km-title">' + esc(item.title) + '</h2>'
          + (tags ? '<div class="km-tags">' + tags + '</div>' : '')
          + '</div><div class="km-row"><span class="km-price">' + price + '</span>' + atc
          + '<a class="km-cta" href="' + esc(item.url) + '">' + esc(t.learnMore) + ' <span aria-hidden="true">→</span></a></div></div>';
        el.innerHTML = html;
        el._item = item;
        el._priceHtml = price;
        el._sel = null;
        stage.appendChild(el);
        cards.push(el);
      });
    }

    /* ---- responsive mode (phone forced-landscape via the rotate button) ---- */
    function viewW() {
      return km.classList.contains('km--rot') ? window.innerHeight : window.innerWidth;
    }
    function viewH() {
      return km.classList.contains('km--rot') ? window.innerWidth : window.innerHeight;
    }
    function applyMode() {
      var iw = window.innerWidth;
      var ih = window.innerHeight;
      var portrait = ih >= iw;
      var phone = Math.min(iw, ih) < 768; /* phone-sized */
      var touchUI = phone && (iw < 768 || coarse.matches);
      var realLand = !portrait && ih <= 500;
      if (!portrait) {
        rotated = false; /* physically turned: no double rotation */
      }
      var rot = rotated && portrait && iw < 768;
      km.classList.toggle('km--touch', touchUI);
      km.classList.toggle('km--rot', rot);
      km.classList.toggle('km--land', rot || realLand);
      km.classList.toggle('km--landreal', realLand);
      km.style.setProperty('--rw', ih + 'px');
      km.style.setProperty('--rh', iw + 'px');
      var btns = km.querySelectorAll('.km-rot');
      for (var i = 0; i < btns.length; i++) {
        btns[i].setAttribute('aria-pressed', rot ? 'true' : 'false');
        btns[i].setAttribute('aria-label', rot ? t.unrotate : t.rotate);
      }
    }
    function toggleRotate() {
      closePicker(false);
      rotated = !rotated; /* only meaningful in portrait */
      applyMode();
      layout(false);
      var btn = cards[active] ? cards[active].querySelector('.km-rot') : null;
      if (btn) {
        btn.focus({ preventScroll: true });
      }
    }

    /* ---- carousel sizing / layout ---- */
    function dims() {
      var W = viewW();
      var H = viewH();
      var cw, gap;
      var lg = W >= 768 && H > 500;
      km.classList.toggle('km--lg', lg);
      if (km.classList.contains('km--land')) {
        cw = Math.round(Math.max(280, Math.min(W - 88, 760)));
        gap = 24;
        km.style.setProperty('--cw', cw + 'px');
        mountListBar();
        var lih;
        if (cards.length) {
          cards.forEach(function (el) {
            var bar = el.querySelector('.km-bar');
            if (bar) {
              bar.classList.remove('is-stack');
            }
          });
          cards.forEach(function (el) {
            var bar = el.querySelector('.km-bar');
            if (!bar) {
              return;
            }
            bar.offsetHeight; /* flush the unwrapped layout before measuring */
            var row = el.querySelector('.km-row');
            var id = el.querySelector('.km-id');
            if (row && id && row.offsetTop >= id.offsetTop + id.offsetHeight - 1) { /* row wrapped below the title block */
              bar.classList.add('is-stack');
            }
          });
          /* the collection row lives only in the active card; every card reserves room for it */
          var maxBar = 0;
          cards.forEach(function (el) {
            var bar = el.querySelector('.km-bar');
            if (bar) {
              maxBar = Math.max(maxBar, bar.offsetHeight);
            }
          });
          var maxChrome = (listBar && listBar.parentNode ? listBar.offsetHeight : 0) + maxBar;
          lih = Math.round(Math.max(96, Math.min(H - LAND_TOP - LAND_BOTTOM - maxChrome, cw / 2)));
        } else {
          lih = Math.max(140, H - 200);
        }
        km.style.setProperty('--lih', lih + 'px');
      } else if (W < 768) {
        cw = W - 28;
        gap = 8;
      } else if (H <= 500) {
        cw = Math.min(W - 120, (H - 130) * 2);
        gap = 24;
      } else {
        /* desktop card ~50vw, clamped 640..960 (never wider than W - 200) */
        cw = Math.round(Math.min(W - 200, Math.max(640, Math.min(960, W * 0.5))));
        gap = Math.round(Math.min(32, W * 0.022));
      }
      km.style.setProperty('--cw', cw + 'px');
      if (lg) {
        var current = cards[active] || cards[0];
        var bar = current ? (current.querySelector('.km-bar').offsetHeight || 104) : 104;
        var ih = Math.round(Math.min(H - 140 - bar, cw / 1.7));
        var is = Math.round(Math.min(0.80 * cw / 0.85, 0.74 * ih / 0.437));
        km.style.setProperty('--ih', ih + 'px');
        km.style.setProperty('--is', is + 'px');
      }
      return { cw: cw, gap: gap, W: W };
    }

    function layout(anim) {
      var d = dims();
      var count = currentItems.length;
      if (!count || !cards[active]) {
        return;
      }
      mountListBar();
      var half = Math.floor(count / 2);
      cards.forEach(function (el, i) {
        var off = ((i - active) % count + count) % count;
        if (off > half) {
          off -= count;
        }
        var prev = el.dataset.off === undefined ? off : +el.dataset.off;
        el.classList.toggle('no-anim', anim === false || Math.abs(off - prev) > 1);
        el.dataset.off = off;
        var side = off !== 0;
        var mob = d.W < 768;
        var sc = side && !mob ? 0.84 : 1;
        var x = off * (d.cw + d.gap) - (side && !mob ? Math.sign(off) * d.cw * 0.08 : 0);
        el.style.transform = 'translateX(' + x + 'px) translateY(-50%) scale(' + sc + ')';
        el.style.opacity = side ? (mob ? 0.9 : 0.45) : 1;
        el.classList.toggle('is-side', side);
        el.classList.toggle('is-hidden', Math.abs(off) > 1);
        el.inert = side;
        el.setAttribute('aria-hidden', side ? 'true' : 'false');
        if (Math.abs(off) <= 2) {
          var im = el.querySelector('.km-img img');
          if (im && !im.getAttribute('src')) {
            im.src = im.dataset.src;
          }
        }
      });
      var cardH = cards[active].offsetHeight;
      km.style.setProperty('--chh', (cardH / 2) + 'px');
      /* Vertical placement: nudge the active card (neighbours, arrows and the
         counter all share --ky) slightly above the vertical centre: target top
         gap is 40% of the free space, bottom gap 60%. Clamped so the card never
         hides behind the mobile close button or the counter under it. */
      var free = viewH() - cardH;
      var landscape = km.classList.contains('km--land');
      var mobile = d.W < 768 && !landscape;
      var minTop = landscape ? LAND_TOP : (mobile ? 76 : 16);
      var minBottom = landscape ? LAND_BOTTOM : (mobile ? 16 : 62);
      var ky = -0.1 * free;
      var kyMin = minTop - free / 2;    /* keeps the top gap >= minTop */
      var kyMax = free / 2 - minBottom; /* keeps the bottom gap >= minBottom */
      if (kyMin > kyMax && landscape) {
        /* landscape too short even with the smallest image: keep the price / Learn More
           row on screen and let the top edge slide up under the close button instead */
        ky = Math.max(kyMax, 8 - free / 2);
      } else {
        ky = kyMin > kyMax ? kyMin : Math.max(kyMin, Math.min(kyMax, ky));
      }
      km.style.setProperty('--ky', Math.round(ky) + 'px');
      counterEl.innerHTML = '<b>' + (active + 1) + '</b> / ' + count;
      updateListBar();
    }

    function go(dir) {
      if (!currentItems.length) {
        return;
      }
      closePicker(false);
      active = ((active + dir) % currentItems.length + currentItems.length) % currentItems.length;
      layout();
      var target = cards[active].querySelector('.km-cta');
      if (target) {
        target.focus({ preventScroll: true });
      }
    }

    /* ---- multi-variant option picker ('+' -> bubble -> pick -> cart) ----
       Geometry uses offsets in the card's own (unrotated) space so it also
       works when the whole modal is rotated (km--rot). */
    var popCard = null;
    function localBox(node, root) {
      var x = 0;
      var y = 0;
      var n = node;
      while (n && n !== root) {
        x += n.offsetLeft;
        y += n.offsetTop;
        n = n.offsetParent;
      }
      return { x: x, y: y, w: node.offsetWidth, h: node.offsetHeight };
    }
    function positionPicker(el) {
      var pop = el.querySelector('.km-pop');
      var row = el.querySelector('.km-row');
      var btn = el.querySelector('.km-atc2');
      if (!pop || !row || !btn) {
        return;
      }
      pop.classList.remove('is-scroll');
      pop.style.maxHeight = '';
      var rb = localBox(row, el);
      var bb = localBox(btn, el);
      var w = pop.offsetWidth;
      var bc = bb.x + bb.w / 2;
      var left = Math.max(8, Math.min(el.offsetWidth - 8 - w, bc - w / 2));
      pop.style.left = (left - rb.x) + 'px';
      pop.style.setProperty('--tail', (bc - left) + 'px');
      var room = rb.y - 18;
      if (pop.offsetHeight > room) {
        pop.style.maxHeight = Math.max(120, room) + 'px';
        pop.classList.add('is-scroll');
      }
    }
    function closePicker(returnFocus) {
      if (!popCard) {
        return;
      }
      var el = popCard;
      popCard = null;
      var pop = el.querySelector('.km-pop');
      if (pop) {
        pop.parentNode.removeChild(pop);
      }
      var btn = el.querySelector('.km-atc2');
      if (btn) {
        btn.classList.remove('is-open');
        if (btn.classList.contains('km-atc2--pick')) {
          btn.setAttribute('aria-expanded', 'false');
        }
        if (returnFocus) {
          btn.focus({ preventScroll: true });
        }
      }
    }
    function openPicker(el) {
      closePicker(false);
      var item = el._item;
      var row = el.querySelector('.km-row');
      var btn = el.querySelector('.km-atc2');
      if (!item || !item.variants || !row || !btn) {
        return;
      }
      var pop = document.createElement('div');
      pop.className = 'km-pop';
      pop.setAttribute('role', 'listbox');
      pop.setAttribute('aria-label', t.chooseOption);
      var html = '<div class="km-pop-h" aria-hidden="true">' + esc(t.chooseOption) + '</div>';
      item.variants.forEach(function (v, i) {
        var on = !!(el._sel && el._sel.id === v.id);
        html += '<button type="button" class="km-opt' + (v.available ? '' : ' is-so') + '" role="option" data-i="' + i + '" aria-selected="' + (on ? 'true' : 'false') + '"'
          + (v.available ? '' : ' disabled aria-disabled="true"') + '>'
          + '<span class="km-opt-ck">' + (on ? icons.check : '') + '</span>'
          + '<span class="km-opt-t">' + esc(v.title) + '</span>'
          + '<span class="km-opt-p">' + (v.available ? v.price : esc(t.soldOut)) + '</span></button>';
      });
      pop.innerHTML = html;
      row.appendChild(pop);
      popCard = el;
      btn.classList.add('is-open');
      if (btn.classList.contains('km-atc2--pick')) {
        btn.setAttribute('aria-expanded', 'true');
      }
      positionPicker(el);
      var f = pop.querySelector('.km-opt[aria-selected="true"]') || pop.querySelector('.km-opt:not(:disabled)');
      if (f) {
        f.focus({ preventScroll: true });
      }
    }
    function togglePicker(el) {
      if (popCard === el) {
        closePicker(true);
      } else {
        openPicker(el);
      }
    }
    function pickVariant(el, i) {
      var v = el && el._item && el._item.variants ? el._item.variants[i] : null;
      if (!v || !v.available) {
        return;
      }
      el._sel = v;
      syncHeart(el, v);
      closePicker(false);
      var price = el.querySelector('.km-price');
      if (price) {
        price.innerHTML = v.price;
        price.classList.add('is-pick');
      }
      var btn = el.querySelector('.km-atc2');
      if (btn) {
        btn.classList.remove('km-atc2--pick', 'is-open');
        btn.removeAttribute('aria-haspopup');
        btn.removeAttribute('aria-expanded');
        btn.setAttribute('aria-label', t.addToCart);
        btn.innerHTML = icons.cart;
      }
      var id = el.querySelector('.km-id');
      var line = el.querySelector('.km-sel');
      if (!line && id) {
        line = document.createElement('p');
        line.className = 'km-sel';
        id.appendChild(line);
      }
      if (line) {
        line.innerHTML = icons.check + '<span>' + esc(v.title) + ' · <button type="button" class="km-sel-change">' + esc(t.change) + '</button></span>';
      }
      var bar = el.querySelector('.km-bar');
      if (bar) {
        bar.classList.add('has-sel');
      }
      layout(false);
      if (btn) {
        btn.focus({ preventScroll: true });
      }
    }
    function resetPick(el) {
      var btn = el.querySelector('.km-atc2');
      if (btn) {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      }
      if (!el._sel) {
        return;
      }
      el._sel = null;
      syncHeart(el, null);
      var price = el.querySelector('.km-price');
      if (price) {
        price.innerHTML = el._priceHtml || '';
        price.classList.remove('is-pick');
      }
      if (btn) {
        btn.className = 'km-atc2 km-atc2--pick';
        btn.setAttribute('aria-label', t.chooseOptions);
        btn.setAttribute('aria-haspopup', 'listbox');
        btn.setAttribute('aria-expanded', 'false');
        btn.innerHTML = icons.plus;
      }
      var line = el.querySelector('.km-sel');
      if (line) {
        line.parentNode.removeChild(line);
      }
      var bar = el.querySelector('.km-bar');
      if (bar) {
        bar.classList.remove('has-sel');
      }
    }

    /* ---- add to cart (single variant, or the variant picked in the option picker) ---- */
    var SECTIONS = [
      { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
      { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
      { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-secondary-area--item-count' },
      { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-secondary-area--item-amount' }
    ];
    function showStatus(message) {
      if (!statusEl) {
        return;
      }
      statusEl.textContent = message || '';
      statusEl.classList.add('is-on');
      window.clearTimeout(statusTimer);
      statusTimer = window.setTimeout(hideStatus, 6000);
    }
    function hideStatus() {
      if (!statusEl) {
        return;
      }
      window.clearTimeout(statusTimer);
      statusEl.textContent = '';
      statusEl.classList.remove('is-on');
    }
    function renderCartSections(state) {
      if (!state || !state.sections) {
        return;
      }
      SECTIONS.forEach(function (section) {
        var host = document.getElementById(section.id);
        var html = state.sections[section.section];
        if (!host || !html) {
          return;
        }
        var target = host.querySelector(section.selector) || host;
        var parsedSection = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
        if (parsedSection) {
          target.innerHTML = parsedSection.innerHTML;
        }
      });
    }
    function quickAdd(button, el) {
      var item = el._item;
      var variants = item && item.variants ? item.variants : [];
      var variant = el._sel || variants.filter(function (v) {
        return String(v.id) === String(item && item.variant);
      })[0] || null;
      var variantId = variant ? variant.id : (item ? item.variant : null);
      if (!item || !variantId || button.disabled) {
        return;
      }
      var wishlistData = wishlistMeta(item, variant);
      wishlistData.id = item.id;
      wishlistData.handle = item.handle;
      wishlistData.variantId = variantId;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);
      formData.append('sections', sectionUrls);
      formData.append('sections_url', window.location.pathname);
      var url = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add';
      fetch(url, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        },
        body: formData
      }).then(function (response) {
        return response.json();
      }).then(function (response) {
        if (response && response.status) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          showStatus(response.description || response.message || t.addError);
          return;
        }
        showStatus(t.added);
        if (window.YPWishlist && typeof window.YPWishlist.publish === 'function') {
          window.YPWishlist.publish('wishlist_add_to_cart', wishlistData, 'modal');
        }
        close();
        renderCartSections(response);
        var drawer = document.getElementById('Cart-Drawer');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        }
        if (drawer && typeof drawer.removeProductEvent === 'function') {
          drawer.removeProductEvent();
        }
        if (typeof window.dispatchCustomEvent === 'function') {
          window.dispatchCustomEvent('cart:item-added', { product: response && response.items ? response.items[0] : response });
        }
      }).catch(function () {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        showStatus(t.addError);
      });
    }

    /* ---- scroll lock (iOS-safe) ---- */
    function lockScroll() {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var scrollbar = window.innerWidth - document.documentElement.clientWidth;
      scrollLock = { y: y, style: document.body.getAttribute('style') };
      var s = document.body.style;
      s.position = 'fixed';
      s.top = (-y) + 'px';
      s.left = '0';
      s.right = '0';
      s.width = '100%';
      s.overflow = 'hidden';
      if (scrollbar > 0) {
        s.paddingRight = scrollbar + 'px';
      }
    }
    function unlockScroll() {
      if (!scrollLock) {
        return;
      }
      if (scrollLock.style === null) {
        document.body.removeAttribute('style');
      } else {
        document.body.setAttribute('style', scrollLock.style);
      }
      var y = scrollLock.y;
      scrollLock = null;
      try {
        window.scrollTo({ top: y, left: 0, behavior: 'instant' });
      } catch (e) {
        window.scrollTo(0, y);
      }
    }

    /* ---- open / close ---- */
    function openIndex(listKey, i, openerEl) {
      var nextListKey = lists ? resolveListKey(listKey) : null;
      var nextItems = itemsForList(nextListKey);
      if (!nextItems.length) {
        return false;
      }
      currentListKey = nextListKey;
      currentItems = nextItems;
      build();
      if (openerEl) {
        opener = openerEl;
      }
      var index = Number(i);
      if (!isFinite(index)) {
        index = 0;
      }
      active = Math.max(0, Math.min(currentItems.length - 1, Math.floor(index)));
      if (!isOpen) {
        isOpen = true;
        hideStatus();
        lockScroll();
        cards.forEach(function (el) {
          delete el.dataset.off;
        });
      }
      km.hidden = false;
      km.classList.add('is-open');
      makeListBar();
      applyMode();
      layout(false);
      window.setTimeout(function () {
        if (!isOpen) {
          return;
        }
        layout(false);
        var target = cards[active] ? cards[active].querySelector('.km-cta') : null;
        if (target) {
          target.focus({ preventScroll: true });
        }
      }, 60);
      return true;
    }
    function close() {
      if (!isOpen) {
        return;
      }
      isOpen = false;
      rotated = false;
      closePicker(false);
      cards.forEach(resetPick);
      applyMode();
      km.classList.remove('is-open');
      km.hidden = true;
      hideStatus();
      unlockScroll();
      if (opener && document.contains(opener) && typeof opener.focus === 'function') {
        opener.focus({ preventScroll: true });
      }
      opener = null;
    }
    function openByHandle(handleOrIndex, listKey, openerEl) {
      if (typeof handleOrIndex === 'number') {
        return openIndex(listKey, handleOrIndex, openerEl || null);
      }
      var target = resolveHandleTarget(handleOrIndex, listKey);
      if (!target) {
        return false;
      }
      return openIndex(target.listKey, target.index, openerEl || null);
    }
    function openList(listKey, openerEl) {
      return openIndex(listKey, 0, openerEl || null);
    }

    /* ---- opening from the homepage cards ----
       A plain click anywhere on a homepage card (image, title, price, empty
       area, See Details pill) opens the modal at that product. The links keep
       their real hrefs for SEO / no-JS. Modifier clicks (new tab, download, …),
       clicks on other interactive bits (compare checkbox, badge controls,
       [data-no-kmodal]) and drags / swipes of the row keep their normal
       browser behaviour. Middle click fires auxclick, which we never touch. */
    var cardPointer = { active: false, type: '', x: 0, y: 0, lastX: 0, lastY: 0 };

    document.addEventListener('pointerdown', function (e) {
      cardPointer.active = false; /* reset on each pointerdown */
      var target = e.target instanceof Element ? e.target : null;
      if (!target || !target.closest('[data-kmodal-card]')) {
        return;
      }
      cardPointer.active = true;
      cardPointer.type = e.pointerType || '';
      cardPointer.x = e.clientX;
      cardPointer.y = e.clientY;
      cardPointer.lastX = e.clientX;
      cardPointer.lastY = e.clientY;
    }, { passive: true });

    document.addEventListener('pointermove', function (e) {
      if (!cardPointer.active) {
        return;
      }
      cardPointer.lastX = e.clientX;
      cardPointer.lastY = e.clientY;
    }, { passive: true });

    document.addEventListener('pointerup', function (e) {
      if (!cardPointer.active) {
        return;
      }
      cardPointer.lastX = e.clientX;
      cardPointer.lastY = e.clientY;
    }, { passive: true });

    function cardPointerMoved() {
      var dx = cardPointer.lastX - cardPointer.x;
      var dy = cardPointer.lastY - cardPointer.y;
      return dx * dx + dy * dy > CARD_DRAG_LIMIT * CARD_DRAG_LIMIT;
    }

    /* Nearest interactive ancestor of the click within the card. A link (or a
       See Details pill rendered as a button) still opens the modal; anything
       else keeps its own behaviour. */
    function cardInteractive(el, boundary) {
      while (el) {
        if (el.hasAttribute && el.hasAttribute('data-no-kmodal')) {
          return true;
        }
        var tag = el.tagName;
        if (tag === 'A') {
          return false;
        }
        if (tag === 'INPUT' || tag === 'SELECT' || tag === 'TEXTAREA' || tag === 'LABEL') {
          return true;
        }
        if (tag === 'BUTTON') {
          return !el.hasAttribute('data-kmodal-open');
        }
        if (el === boundary) {
          break;
        }
        el = el.parentElement;
      }
      return false;
    }

    document.addEventListener('click', function (e) {
      if (e.defaultPrevented) {
        return;
      }
      var target = e.target instanceof Element ? e.target : null;
      if (!target) {
        return;
      }
      var card = target.closest('[data-kmodal-card]');
      var trigger = target.closest('[data-kmodal-open]') || card;
      if (!trigger) {
        return;
      }
      /* modifier clicks keep the browser default (new tab, new window, …) */
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
        return;
      }
      if (cardInteractive(target, card)) {
        return;
      }
      /* a drag / swipe of the row must neither open the modal nor navigate;
         keyboard clicks (e.detail === 0) always open the modal */
      if (e.detail !== 0 && cardPointer.active && cardPointerMoved()) {
        e.preventDefault();
        return;
      }
      var handle = trigger.getAttribute('data-handle') || (card && card.getAttribute('data-handle'));
      var productWrap = trigger.closest('.collection-tabs--product');
      var collectionId = productWrap ? productWrap.getAttribute('data-collection') || '' : '';
      var listKey = collectionId.indexOf('collection-') === 0 ? collectionId.slice('collection-'.length) : null;
      var openTarget = resolveHandleTarget(handle, listKey);
      if (!openTarget) {
        return; /* unknown handle: let the link go to the product page */
      }
      /* return focus to the clicked link, else to the See Details pill */
      var openerEl = target.closest('a');
      if (!openerEl || (card && !card.contains(openerEl))) {
        openerEl = card ? card.querySelector('[data-kmodal-open]') : null;
      }
      e.preventDefault();
      openIndex(openTarget.listKey, openTarget.index, openerEl || trigger);
    });

    /* Header tab and Shop all links keep their collection URLs for modifier
       clicks, middle clicks (which fire auxclick) and no-JS. A direct primary
       click or keyboard Enter opens the matching modal list at its first item. */
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented) {
        return;
      }
      var target = e.target instanceof Element ? e.target : null;
      var trigger = target ? target.closest('[data-kmodal-list]') : null;
      if (!trigger) {
        return;
      }
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
        return;
      }
      var listKey = trigger.getAttribute('data-kmodal-list');
      if (!itemsForListTrigger(listKey).length) {
        return; /* unknown or empty list: keep the link's normal navigation */
      }
      e.preventDefault();
      openList(listKey, trigger);
    });

    /* ---- stage interactions ---- */
    var drag = { x: null, y: null, dx: 0, dragged: false };
    stage.addEventListener('click', function (e) {
      var clicked = e.target instanceof Element ? e.target : null;
      if (clicked && clicked.closest('a.km-view')) {
        return; /* modal's collection link navigates normally */
      }
      if (drag.dragged) {
        e.stopPropagation();
        return;
      }
      var target = clicked;
      if (!target) {
        return;
      }
      if (target.closest('.km-pop')) {
        var opt = target.closest('.km-opt');
        if (opt && !opt.disabled) {
          pickVariant(opt.closest('.km-card'), +opt.getAttribute('data-i'));
        }
        e.stopPropagation();
        return;
      }
      var el = target.closest('.km-card');
      var pickTrigger = el && (target.closest('.km-atc2--pick') || (el._sel && (target.closest('.km-sel') || target.closest('.km-price'))));
      if (popCard && !(pickTrigger && el === popCard)) {
        /* outside tap only closes the bubble */
        closePicker(false);
        if (!el || !el.classList.contains('is-side')) {
          return;
        }
      }
      if (!el) {
        if (target === stage) {
          close();
        }
        return;
      }
      if (el.classList.contains('is-side')) {
        go(+el.dataset.off);
        return;
      }
      if (target.closest('.km-rot')) {
        e.stopPropagation();
        toggleRotate();
        return;
      }
      if (target.closest('.km-img')) {
        return;
      }
      if (pickTrigger) {
        togglePicker(el);
        return;
      }
      var atc = target.closest('.km-atc2');
      if (atc) {
        quickAdd(atc, el);
      }
    });
    stage.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });
    stage.addEventListener('pointerdown', function (e) {
      var pt = e.target instanceof Element ? e.target : null;
      if (pt && pt.closest('a.km-view')) {
        drag.x = null; /* the modal's collection link never starts a drag */
        return;
      }
      if (pt && pt.closest('.km-pop, .km-atc2, .km-sel, [data-wishlist-toggle]')) {
        drag.x = null; /* bubble / its triggers / the wishlist heart never start a carousel drag */
        return;
      }
      drag.x = e.clientX;
      drag.y = e.clientY;
      drag.dx = 0;
    }, { passive: true });
    stage.addEventListener('pointermove', function (e) {
      if (drag.x === null) {
        return;
      }
      var dx;
      var dy;
      if (km.classList.contains('km--rot')) {
        /* modal is rotated +90deg clockwise: its local x axis is screen +y */
        dx = e.clientY - drag.y;
        dy = -(e.clientX - drag.x);
      } else {
        dx = e.clientX - drag.x;
        dy = e.clientY - drag.y;
      }
      drag.dx = dx;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > SWIPE_START) {
        cards.forEach(function (el) {
          el.classList.add('no-anim');
          var m = el.style.transform.match(/translateX\(([-\d.]+)px\)(.*)/);
          if (m) {
            el._bx = el._bx == null ? +m[1] : el._bx;
            el.style.transform = 'translateX(' + (el._bx + drag.dx) + 'px)' + m[2];
          }
        });
      }
    }, { passive: true });
    function endDrag() {
      if (drag.x === null) {
        return;
      }
      if (Math.abs(drag.dx) > SWIPE_START) {
        drag.dragged = true;
        window.setTimeout(function () {
          drag.dragged = false;
        }, 350);
      }
      cards.forEach(function (el) {
        delete el._bx;
      });
      var dir = Math.abs(drag.dx) > SWIPE_GO ? (drag.dx < 0 ? 1 : -1) : 0;
      drag.x = null;
      if (dir) {
        go(dir);
      } else {
        layout();
      }
    }
    stage.addEventListener('pointerup', endDrag);
    stage.addEventListener('pointercancel', endDrag);

    km.querySelector('.km-prev').addEventListener('click', function () {
      go(-1);
    });
    km.querySelector('.km-next').addEventListener('click', function () {
      go(1);
    });
    km.querySelector('.km-close').addEventListener('click', close);
    km.querySelector('.km-backdrop').addEventListener('click', function () {
      if (popCard) {
        closePicker(false); /* first outside tap only closes the option bubble */
        return;
      }
      close();
    });

    /* ---- keyboard ---- */
    document.addEventListener('keydown', function (e) {
      if (!isOpen || e.defaultPrevented) {
        return;
      }
      if (e.key === 'Escape') {
        if (popCard) {
          closePicker(true); /* first Esc closes the bubble */
          return;
        }
        close();
        return;
      }
      if (popCard && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
        var opts = Array.prototype.slice.call(popCard.querySelectorAll('.km-opt:not(:disabled)'));
        if (opts.length) {
          e.preventDefault();
          var k = opts.indexOf(document.activeElement);
          k = e.key === 'ArrowDown' ? (k + 1) % opts.length : (k <= 0 ? opts.length - 1 : k - 1);
          opts[k].focus({ preventScroll: true });
        }
        return;
      }
      if (e.metaKey || e.ctrlKey || e.altKey) {
        return;
      }
      var target = e.target instanceof Element ? e.target : null;
      var tag = target ? target.tagName : '';
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || (target && target.isContentEditable)) {
        return;
      }
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        go(1);
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        go(-1);
      } else if (e.key === 'Tab') {
        var focusables = Array.prototype.slice.call(km.querySelectorAll('button, a[href], [tabindex="0"]')).filter(function (x) {
          return !x.closest('[inert]') && x.offsetParent !== null && !x.disabled;
        });
        if (!focusables.length) {
          return;
        }
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        var current = document.activeElement;
        if (e.shiftKey && (current === first || !km.contains(current))) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && (current === last || !km.contains(current))) {
          e.preventDefault();
          first.focus();
        }
      }
    });

    /* ---- resize / orientation (rAF-throttled) ---- */
    var frame = 0;
    function onViewportChange() {
      if (!isOpen || frame) {
        return;
      }
      frame = window.requestAnimationFrame(function () {
        frame = 0;
        if (!isOpen) {
          return;
        }
        var wasPortrait = lastPortrait;
        lastPortrait = window.innerHeight >= window.innerWidth;
        if (popCard && wasPortrait !== lastPortrait) {
          closePicker(false); /* orientation flip closes the bubble */
        }
        applyMode();
        layout(false);
        if (popCard) {
          positionPicker(popCard);
        }
      });
    }
    var lastPortrait = window.innerHeight >= window.innerWidth;
    window.addEventListener('resize', onViewportChange);
    window.addEventListener('orientationchange', onViewportChange);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', onViewportChange);
    }

    window.KeycapModal = {
      open: openByHandle,
      openList: openList,
      close: close
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
